import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zh from 'element-plus/lib/locale/lang/zh-cn' // 简体中文
import zhTw from 'element-plus/lib/locale/lang/zh-tw' // 繁体中文
import en from 'element-plus/lib/locale/lang/en' // 英文
import vue3TreeOrg from 'vue3-tree-org';
import "vue3-tree-org/lib/vue3-tree-org.css";
import * as echarts from 'echarts';//引入echarts
import * as ElementPlusIconsVue from '@element-plus/icons-vue'; //全局引入图标
import './icons'
import SvgIcon from './components/svgIcon.vue'
import './style/index.less'
import directives from "@/utils/carbonButler/directive";

import i18n from './locals'

const app = createApp(App);
app.config.warnHandler = () => null // 去除控制台警告信息
app.config.globalProperties.$echarts = echarts;//全局使用
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {  //全局引入图标
  app.component(key, component)
}
app.use(store);
app.use(router);
app.use(directives);
// if (store.state.language === 'zh') {
//   app.use(ElementPlus, { locale: zh })
// } else if (store.state.language === 'zhTw') {
//   app.use(ElementPlus, { locale: zhTw })
// } else if (store.state.language === 'en') {
//   app.use(ElementPlus, { locale: en })
// } else {
//   app.use(ElementPlus, { locale: zh })
// }
// app.use(ElementPlus, { locale: zh }); // ElementPlus 自带国际化
app.use(ElementPlus); // ElementPlus
app.use(i18n) // 自定义的国际化
// 引入SvgIcon
app.component('svg-icon', SvgIcon)
app.use(vue3TreeOrg);

app.mount("#app");

export default app
